module.exports = __webpack_public_path__ + "media/images/story-38abb3aac940933d8a710660cc80f7e1.png";